import { bindStickyFiltersClick } from '../../Shared/js/utils/bindStickyFilters';

(function () {
    'use strict';

    wo$(function () {
        var page = wo$('#landing');
        if (!page.length) return;

        var landingPageController = {
            init: function () {
                wo$('#express-search-action').hide();
                WhistleOut.getAds('Broadband');
                bindStickyFiltersClick(wo$('#sticky-filters'));
            }
        };

        landingPageController.init();
    });
})();
